import { render, staticRenderFns } from "./CategoryDelete.vue?vue&type=template&id=7b1ded1c&"
import script from "./CategoryDelete.vue?vue&type=script&lang=js&"
export * from "./CategoryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../.nvm/versions/node/v18.15.0/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports